var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.2 460.803C339.575 460.803 311.375 440.005 297.625 412.805L335.875 390.649C345.95 407.099 359.025 419.177 382.2 419.177C401.65 419.177 414.075 409.445 414.075 396.021C414.075 375.82 387.125 367.928 368.1 359.778C334.2 345.353 311.7 327.228 311.7 288.953C311.7 253.728 338.55 226.88 380.525 226.88C410.375 226.88 431.875 237.278 447.3 264.453L410.725 287.952C402.675 273.527 393.95 267.822 380.525 267.822C366.75 267.822 358.025 276.552 358.025 287.952C358.025 302.052 366.75 307.754 386.9 316.479C429.125 334.579 461.075 348.799 461.075 395.349C461.075 437.649 427.85 460.803 383.2 460.803ZM275 389.978C275 438.653 245.025 464.38 203.4 464.38C165.8 464.38 143.275 450 132.2 425H131.825H131.65H131.55L169.775 398.279C177.15 411.354 183.8 420.63 199.9 420.63C215.35 420.63 225 412.806 225 389.331V225H275V389.978ZM0 500H500V0H0V500Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.76c901bb5c4341a60c53b837ee027034.svg";
export { ForwardRef as ReactComponent };